import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { ComponentChanges } from '@app/shared/components/scope-elements/models/entities-with-changes/component-with-changes.interface'

export function getComponentChanges(component: ScopeComponent, previewComponent: ScopeComponent): ComponentChanges {
  return {
    quantity: {
      old: component?.quantity,
      new: previewComponent?.quantity,
    },
    rateCardTotalHours: {
      old: component?.getTotalRateCardHours(),
      new: previewComponent?.getTotalRateCardHours(),
    },
    agencyPrice: {
      old: component?.getTotalSellingPrice()?.amount,
      new: previewComponent?.getTotalSellingPrice()?.amount,
    },
    markup: {
      old: component?.getMarkup(),
      new: previewComponent?.getMarkup(),
    },
    totalSellingPrice: {
      old: component?.getTotalSellingPrice()?.amount,
      new: previewComponent?.getTotalSellingPrice()?.amount,
    },
  }
}
